<template>
  <div class="container-fluid padding-right-0px">
    <div class="missionCheckinsStepList">
      <div class="row padding-top-13px padding-left-3px" v-if="getShowUIValue">
        <div class="col-md-12 col-lg-12 padding-right-0px padding-left-35px">
          <ul class="col-md-12 col-lg-12 text-align-left padding-left-0px padding-right-0px">
            <li class="padding-3px">
              <div class="row vertical-align">
                <div class="filled-circle col-md-1 col-lg-1 cursor-pointer text-color-white background-color-orange">{{getCurrentlyRenderedElementObj.DisplayIndex}}</div>  
                <div class="col-md-9 col-lg-9">
                  <div class="row">
                    <span class="col-md-12 col-lg-12 orange-text-color">
                      {{currElementTypeValue}}
                    </span>
                  </div>
                  <div class="row orange-text-color">
                    <div class="col-md-12 col-lg-12">
                      {{getCurrentlyRenderedElementObj.Title}}
                    </div>
                  </div>
                </div>
                <div class="col-md-2 col-lg-2 text-align-right">
                </div>
              </div>
              <!-- START Create Mission Check-In UI -->
              <div class="row vertical-align padding-top-13px">
                <div class="col-md-1 col-lg-1 text-align-center" v-if="hideCreateMissionCheckIn && !showAddedCheckedIn && !showEditCheckInUI">
                  <span class="glyphicon glyphicon-plus-sign color-green padding-right-0px col-md-12 col-lg-12 cursor-pointer" @click="updateShowMissionCheckInFlag($event, false)"></span>
                </div>
                <div class="col-md-5 col-lg-5">
                  <div class="form-group" v-if="!hideCreateMissionCheckIn && !showAddedCheckedIn && !showEditCheckInUI">
                    <div class="col-sm-12 padding-left-24px padding-right-0px">
                      <input class="form-control inputdefault" type="text" v-model="MissionCheckInTitleValue" placeholder="Check-In Title">
                    </div>
                  </div>
                </div>
                <div class="col-md-2 col-lg-2 padding-left-0px text-align-right">
                  <button class="btn btn-primary create-lesson-overlay-button-BG black-font-color padding-6px-23px" v-if="!hideCreateMissionCheckIn && !showAddedCheckedIn && !showEditCheckInUI" @click="addMissionCheckIn">Add Check-In</button>
                </div>
                <div class="col-md-2 col-lg-2 padding-left-0px">
                  <button class="btn btn-primary create-lesson-overlay-button-BG black-font-color" v-if="!hideCreateMissionCheckIn && !showAddedCheckedIn && !showEditCheckInUI" @click="updateShowMissionCheckInFlag($event, true)">Cancel</button>
                </div>
                <div class="col-md-2 col-lg-2 padding-left-0px">
                </div>
              </div>
              <!-- END Create Mission Check-In UI -->
              <!-- START Update Mission Check-In UI -->
              <div class="row padding-top-13px">
                <div class="col-md-1 col-lg-1 padding-left-0px" v-if="false">
                </div>
                <div class="col-md-5 col-lg-5" v-if="!hideCreateMissionCheckIn && !showAddedCheckedIn && showEditCheckInUI">
                  <div class="form-group">
                    <div class="col-sm-12 padding-left-24px padding-right-0px">
                      <input class="form-control inputdefault" type="text" v-model="MissionCheckInTitleValue" placeholder="Check-In Title">
                    </div>
                  </div>
                </div>
                <div class="col-md-2 col-lg-2 padding-left-0px text-align-right">
                  <button class="btn btn-primary create-lesson-overlay-button-BG black-font-color" v-if="!hideCreateMissionCheckIn && !showAddedCheckedIn && showEditCheckInUI" @click="updateMissionCheckIn">Update Check-In</button>
                </div>
                <div class="col-md-2 col-lg-2 padding-left-0px">
                  <button class="btn btn-primary create-lesson-overlay-button-BG black-font-color" v-if="!hideCreateMissionCheckIn && !showAddedCheckedIn && showEditCheckInUI" @click="dismissUpdateCheckInUI">Cancel</button>
                </div>
                <div class="col-md-2 col-lg-2 padding-left-0px">
                </div>
              </div>
              <!-- END Update Mission Check-In UI -->
              <!-- START Show Mission Checked-In UI -->
              <div class="row vertical-align" v-if="showAddedCheckedIn && !showEditCheckInUI">
                <div class="col-md-1 col-lg-1 text-align-center"><span class="glyphicon glyphicon-flag padding-left-15px"></span></div>  
                <div class="col-md-8 col-lg-8">
                  <div class="row">
                    <span class="col-md-12 col-lg-12 font-weight-bold padding-left-0px">
                      Mission Check-In 
                    </span>
                  </div>
                  <div class="row">
                    <div class="col-md-12 col-lg-12 padding-left-0px">
                      {{getCurrentlyRenderedElementMissionCheckInObj.Title}}
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1">
                  <img src="../../../assets/images/edit.svg" alt="useredit" height="15" width="15" class="cursor-pointer" @click="performOperation($event,'edit')">
                </div>
                <div class="col-md-1 col-lg-1">
                  <img :src="deleteIcon" alt="useredit" height="15" width="15" class="cursor-pointer" @click="performOperation($event,'delete')">
                </div>
                <div class="col-md-1 col-lg-1">
                </div>
              </div>
              <!-- END Show Mission Checked-In UI -->
            </li>
          </ul>
        </div>
      </div>
    </div>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="deleteSelectedMissionCheckIn"></confirmation-alert>
  </div>
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import { elementService } from '@/server-util/element-service'
import edit from '../../../assets/images/edit.svg'
import deleteIcon from '../../../assets/images/delete.svg'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import lodash from 'lodash'
export default {
  props: ['MissionGameResp', 'lessonObj', 'currRenderedModuleObj', 'lessonList', 'elementList', 'currRenderedElementObj', 'missionCheckinAndJourney'],
  created: function () {
    this.getCurrentElementTypeName()
    this.checkAndRenderUI()
    this.setDefaultValues()
  },
  data: function () {
    return {
      useredit: edit,
      deleteIcon: deleteIcon,
      showAlertDialog: false,
      errorMsg: '',
      showConfirmationBox: false,
      prefixString: '',
      postString: '?',
      currElementType: '',
      showUI: true,
      hideCreateMissionCheckIn: true,
      showAddedCheckedIn: false,
      showEditCheckInUI: false,
      checkInResp: '',
      checkInTitleBeforeEdit: ''
    }
  },
  name: 'missionCheckinsStepList',
  methods: {
    dismissUpdateCheckInUI: function () {
      this.showEditCheckInUI = false
      this.showAddedCheckedIn = true
      this.hideCreateMissionCheckIn = true
      this.getCurrentlyRenderedElementMissionCheckInObj.Title = this.checkInTitleBeforeEdit
    },
    performOperation: function (event, operationToPerform) {
      switch (operationToPerform) {
        case 'delete':
          this.showConfirmationBox = true
          this.prefixString = 'Are you sure you want to delete'
          this.postString = ' \'' + this.getCurrentlyRenderedElementMissionCheckInObj.Title + '\' check-in?'
          break
        case 'edit':
          this.checkInTitleBeforeEdit = this.getCurrentlyRenderedElementMissionCheckInObj.Title
          this.showEditCheckInUI = true
          this.showAddedCheckedIn = false
          this.hideCreateMissionCheckIn = false
          break
      }
    },
    setDefaultValues: function () {
      if (this.getCurrentlyRenderedElementObj.MissionCheckIn.MissionCheckInId !== constants.Empty_Guid) {
        this.showEditCheckInUI = false
        this.showAddedCheckedIn = true
        this.hideCreateMissionCheckIn = true
      } else {
        // console.log('this.getCurrentlyRenderedElementObj.MissionCheckIn.MissionCheckInId:' + this.getCurrentlyRenderedElementObj.MissionCheckIn.MissionCheckInId)
        this.getCurrentlyRenderedElementObj.MissionCheckIn.ElementId = this.getMissionResponseObj.ElementId
        this.getCurrentlyRenderedElementObj.MissionCheckIn.Title = ''
        const targetElementObj = this.getCurrentlyRenderedElementObj // this.getTargetElementId()
        if (targetElementObj !== undefined && targetElementObj !== null && targetElementObj !== '' && targetElementObj !== 'null') {
          this.getCurrentlyRenderedElementObj.MissionCheckIn.TargetElementId = targetElementObj.ElementId
        } else {
          console.log('Fail to identify target element.')
        }
      }
    },
    getTargetElementId: function () {
      var targetElementObj = {}
      const currRenderedStepIndex = parseInt(this.getCurrentlyRenderedElementObj.Index)
      // console.log('currRenderedStepIndex >>> ' + currRenderedStepIndex)
      // console.log('this.getCurrentlyRenderedLessonObj >>> ' + JSON.stringify(this.getCurrentlyRenderedLessonObj))
      targetElementObj = lodash.find(this.getCurrentlyRenderedLessonObj.Elements, function (o) {
        return currRenderedStepIndex < o.Index
      })
      var isEmptyTargetObj = lodash.isEmpty(targetElementObj)
      // console.log('isEmptyTargetObj: ' + isEmptyTargetObj)
      if (isEmptyTargetObj) {
        // AK: get next module First element
        const parentModuleIndex = this.getCurrentlyRenderedLessonObj.Index
        // console.log('Parent Module Index: ' + parentModuleIndex)
        var nextModuleObj = lodash.find(this.getLessonListOfCourseJourney, function (o) {
          return parentModuleIndex < o.Index
        })
        // console.log('nextModuleObj: ' + JSON.stringify(nextModuleObj))
        if (nextModuleObj !== undefined && nextModuleObj !== null && nextModuleObj !== '' && nextModuleObj !== 'null') {
          // AK: Get first element of next module
          const nextModuleElementList = nextModuleObj.Elements
          targetElementObj = lodash.find(nextModuleElementList, function (o) {
            return o.Index === 0
          })
        } else {
          // AK: Last module hence return current type only
          targetElementObj = this.getCurrentlyRenderedElementObj
        }
      }
      // console.log('Update targetElementObj: ' + JSON.stringify(targetElementObj))
      return targetElementObj
    },
    addMissionCheckIn: function () {
      if (this.validateRequiredFieldBeforeSubmit()) {
        var _this = this
        var storeObj = this.$store
        if (this.getCurrentlyRenderedElementObj.MissionCheckIn !== undefined && this.getCurrentlyRenderedElementObj.MissionCheckIn !== '' && this.getCurrentlyRenderedElementObj.MissionCheckIn !== 'null') {
          this.$store.state.isLoading = true
          elementService
            .createMissiomCheckIns(storeObj.state.access_token, _this.getCurrentlyRenderedElementObj.MissionCheckIn)
            .then(
              responseObj => {
                if (responseObj.status >= 200 && responseObj.status < 300) {
                  _this.checkInResp = responseObj.data
                  _this.updateCurrentMissionCheckInObj()
                  _this.$store.state.isLoading = false
                  _this.showAddedCheckedIn = true
                  _this.showEditCheckInUI = false
                  _this.hideCreateMissionCheckIn = true
                  // console.log('Updated _this.currRenderedElementObj.MissionCheckIn Object: ' + JSON.stringify(_this.currRenderedElementObj.MissionCheckIn))
                  _this.$emit('addMissionCheckIns', _this.checkInResp)
                } else {
                  // AK: Hide Spinner
                  _this.$store.state.isLoading = false
                  this.showAlertDialog = true
                  this.errorMsg =
                    'Oops! Something went wrong. Please try again.'
                }
              },
              errorObj => {
                // AK: Hide Spinner
                _this.$store.state.isLoading = false
                this.showAlertDialog = true
                if (errorObj.response === undefined) {
                  this.errorMsg = constants.No_Internet_Connection_Msg
                } else {
                  this.errorMsg = errorObj.response.statusText
                }
              }
            )
        } else {
          console.log(
            'Selected Mission Element Id is NULL hence declined GET MISSION CHECKIN AND COURSE JOURNEY OPERATION'
          )
        }
      }
    },
    updateMissionCheckIn: function () {
      if (this.validateRequiredFieldBeforeSubmit()) {
        var _this = this
        var storeObj = this.$store
        if (this.getCurrentlyRenderedElementObj.MissionCheckIn !== undefined && this.getCurrentlyRenderedElementObj.MissionCheckIn !== '' && this.getCurrentlyRenderedElementObj.MissionCheckIn !== 'null') {
          this.$store.state.isLoading = true
          elementService
            .updateMissionCheckIn(storeObj.state.access_token, _this.getCurrentlyRenderedElementObj.MissionCheckIn)
            .then(
              responseObj => {
                if (responseObj.status >= 200 && responseObj.status < 300) {
                  _this.checkInResp = responseObj.data
                  _this.updateCurrentMissionCheckInObj()
                  _this.$store.state.isLoading = false
                  _this.showAddedCheckedIn = true
                  _this.hideCreateMissionCheckIn = true
                  _this.showEditCheckInUI = false
                  // _this.$emit('addMissionCheckIns', _this.checkInResp)
                } else {
                  // AK: Hide Spinner
                  _this.$store.state.isLoading = false
                  this.showAlertDialog = true
                  this.errorMsg =
                    'Oops! Something went wrong. Please try again.'
                }
              },
              errorObj => {
                // AK: Hide Spinner
                _this.$store.state.isLoading = false
                this.showAlertDialog = true
                if (errorObj.response === undefined) {
                  this.errorMsg = constants.No_Internet_Connection_Msg
                } else {
                  this.errorMsg = errorObj.response.statusText
                }
              }
            )
        } else {
          console.log(
            'Selected Mission Element Id is NULL hence declined GET MISSION CHECKIN AND COURSE JOURNEY OPERATION'
          )
        }
      }
    },
    updateCurrentMissionCheckInObj: function () {
      var _this = this
      _this.currRenderedElementObj.MissionCheckIn.MissionCheckInId = _this.checkInResp.MissionCheckInId
      _this.currRenderedElementObj.MissionCheckIn.CreatedTS = _this.checkInResp.CreatedTS
      _this.currRenderedElementObj.MissionCheckIn.UpdatedTS = _this.checkInResp.UpdatedTS
    },
    validateRequiredFieldBeforeSubmit: function () {
      if (this.MissionCheckInTitleValue.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Check-in title can\'t be empty.'
        return false
      }
      return true
    },
    updateShowMissionCheckInFlag: function (event, flagToUpdate) {
      const targetElementObj = this.getCurrentlyRenderedElementObj // this.getTargetElementId()
      // console.log('targetElementObj >>> ' + targetElementObj)
      if (targetElementObj !== undefined && targetElementObj !== null && targetElementObj !== '' && targetElementObj !== 'null') {
        this.getCurrentlyRenderedElementObj.MissionCheckIn.TargetElementId = targetElementObj.ElementId
      } else {
        this.showAlertDialog = true
        this.errorMsg = 'Fail to identify target element.'
      }
      if (flagToUpdate) {
        this.getCurrentlyRenderedElementObj.MissionCheckIn.Title = ''
      }
      this.hideCreateMissionCheckIn = flagToUpdate
    },
    getCurrentElementTypeName: function () {
      switch (this.getCurrentlyRenderedElementObj.Type) {
        case 0:
          this.currElementType = 'Video'
          break
        case 1:
          this.currElementType = 'Challenge'
          break
        case 2:
          this.currElementType = 'Reflection'
          break
        case 3:
          this.currElementType = 'MCQ'
          break
        case 4:
          this.currElementType = 'Tookit'
          break
        case 5:
          this.currElementType = 'Diary'
          break
        case 6:
          this.currElementType = 'Note'
          break
        case 7:
          this.currElementType = 'Bonus'
          break
        case 8:
          this.currElementType = 'Document'
          break
        case 9:
          if (parseInt(this.getCurrentlyRenderedElementObj.RDType) === parseInt(constants.DescVideoType.Teachback)) {
            this.currElementType = 'Teachback'
          } else {
            this.currElementType = 'Descriptive Video'
          }
          break
        case 10:
          this.currElementType = 'Rating'
          break
        case 11:
          this.currElementType = 'Learning Game'
          break
        case 12:
          this.currElementType = 'Mission'
          break
      }
    },
    checkAndRenderUI: function () {
      if (parseInt(this.getCurrentlyRenderedLessonObj.Index) > parseInt(this.getParentLessonObj.Index)) {
        this.showUI = true
      } else if (parseInt(this.getCurrentlyRenderedLessonObj.Index) < parseInt(this.getParentLessonObj.Index)) {
        this.showUI = false
      } else if (parseInt(this.getCurrentlyRenderedLessonObj.Index) === parseInt(this.getParentLessonObj.Index)) {
        if (this.getCurrentlyRenderedElementObj.Index >= this.getMissionResponseObj.Index) {
          this.showUI = true
        } else {
          this.showUI = false
        }
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of delete element overlay
      this.showConfirmationBox = value
    },
    deleteSelectedMissionCheckIn (value) {
      // AK: Hide Delete Confirmation Box
      this.showConfirmationBox = false
      var _this = this
      var storeObj = this.$store
      if (value) {
        if (
          this.getCurrentlyRenderedElementMissionCheckInObj.MissionCheckInId !== undefined
        ) {
          // this.showSpinner = true
          this.$store.state.isLoading = true
          elementService
            .deleteMissionCheckIn(storeObj.state.access_token, _this.getCurrentlyRenderedElementMissionCheckInObj.MissionCheckInId)
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                _this.resetMissionCheckInObj()
                _this.showAddedCheckedIn = false
                _this.hideCreateMissionCheckIn = true
                _this.showEditCheckInUI = false
                _this.$store.state.isLoading = false
              } else {
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
                // this.showSpinner = false
                this.$store.state.isLoading = false
              }
            }, errorObj => {
              // AK: Hide Spinner
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'Selected MissionCheckInId is NULL hence declined DELETE OPERATION'
          )
        }
      }
    },
    resetMissionCheckInObj: function () {
      var _this = this
      _this.currRenderedElementObj.MissionCheckIn.MissionCheckInId = '00000000-0000-0000-0000-000000000000'
      _this.currRenderedElementObj.MissionCheckIn.Title = ''
      _this.currRenderedElementObj.MissionCheckIn.CreatedTS = '0001-01-01T00:00:00'
      _this.currRenderedElementObj.MissionCheckIn.UpdatedTS = '0001-01-01T00:00:00'
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader,
    'confirmation-alert': ConfirmationOverlay
  },
  computed: {
    getMissionCheckinAndJourney: {
      get: function () {
        return this.missionCheckinAndJourney
      }
    },
    MissionCheckInTitleValue: {
      get: function () {
        return this.getCurrentlyRenderedElementObj.MissionCheckIn.Title
      },
      set: function (newValue) {
        this.getCurrentlyRenderedElementObj.MissionCheckIn.Title = newValue
      }
    },
    getShowUIValue: {
      get: function () {
        return this.showUI
      }
    },
    currElementTypeValue: {
      get: function () {
        return this.currElementType
      }
    },
    getParentLessonObj: {
      get: function () {
        return this.lessonObj
      }
    },
    getMissionResponseObj: {
      get: function () {
        return this.MissionGameResp
      }
    },
    getCurrentlyRenderedLessonObj: {
      get: function () {
        return this.currRenderedModuleObj
      }
    },
    getCurrentlyRenderedElementObj: {
      get: function () {
        return this.currRenderedElementObj
      }
    },
    getCurrentlyRenderedElementMissionCheckInObj: {
      get: function () {
        return this.currRenderedElementObj.MissionCheckIn
      }
    },
    getLessonListOfCourseJourney: {
      get: function () {
        return this.lessonList
      }
    },
    getElementList: {
      get: function () {
        return this.elementList
      }
    }
  }
}
</script> 
<style scoped>
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-5Perc
{
	margin-bottom: 5%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-top-2Perc
{
	margin-top: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 25%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-1Perc {
  margin-right: 1%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer !important;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0px {
  padding-right: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
.border-red {
    border:1px solid red;
}
.margin-bottom-2Perc {
    margin-bottom: 2%;
}
.font-size-14px {
    font-size: 14px;
}
.padding-right-6px {
    padding-right:6px; 
}
.padding-top-1Perc {
    padding-top:1%;
}
.padding-left-0px {
    padding-left:0px;
}
.margin-left-10px {
    margin-left: 10px;
}
.padding-3px {
    padding:3px;
}
.padding-bottom-3px {
  padding-bottom:3px;
}
.padding-left-8px {
  padding-left:8px;
}
ul {
  list-style-type: none;
}
.filled-circle {
  height: 25px;
  width: 25px;
  background-color: grey;
  border-radius: 50%;
  display: inline-block;
  text-align: center;
  padding: 2px;
}
.filled-circle-mission-checkin {
  height: 25px;
  width: 25px;
  background-color: blanchedalmond;
  border-radius: 50%;
  display: inline-block;
  text-align: center;
  padding: 2px;
}
.cursor-default {
  cursor:default;
}
.margin-bottom-10px {
  margin-bottom:10px;
}
.background-color-green {
    background-color: #0D9335;
}
.text-color-white {
  color:white;
}
.padding-left-58px {
  padding-left:58px;
}
.padding-top-13px {
  padding-top:13px;
}
.padding-left-3px {
  padding-left:3px;
}
.padding-left-35px {
  padding-left:35px;
}
.width-20px {
  width:20px;
}
.height-20px {
  height:20px;
}
.font-weight-bold {
  font-weight: 600;
}
.background-color-orange {
  background-color: #f39c12;
}
.orange-text-color {
  color: #f39c12;
}
.color-green {
  color:#447417;
}
.padding-6px-23px {
  padding: 6px 23px;
}
.padding-left-24px {
  padding-left:24px;
}
.padding-left-15px {
  padding-left:15px;
}
</style>



// WEBPACK FOOTER //
// src/components/mission_game/update/UpdateMissionCheckinsStepList.vue